import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Loading from '../components/LoadingPage';
import axios from 'axios';
import '../static/css/EditImage.css';
import user from '../static/images/images/user-circle-solid.svg';
import messages from '../static/images/images/comment-dots-solid.svg';
import logout from '../static/images/images/right-from-bracket-solid.svg';
import dot from '../static/images/images/circle-solid.svg';
import MobileFooterNav from './MobileFooterNav';
import logo from '../static/images/images/Motorcyk_SSa-R03a_Mil.png';
import ImageUploading from 'react-images-uploading';
class EditImage extends Component {
    constructor() {
        super();
        this.state = {
            signed_in: localStorage.getItem('token') ? true : false,
            active: false,
            status: '',
            isLoading: true,
            redirect: false,
            ui: null,
            user: '',
            image: null,
            image_url: null,
            disabled: false,
            new_image: null,
            file_name: null,
            end: null,
            cancelled: false,
            message_unread: false,
            trial_used: false,
            non_active: false,
            error: false,
        };
        this.onSubmit = this.onSubmit.bind(this);
    };
    async componentDidMount () {
        const token = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${token}`, } };
        await axios.post(process.env.REACT_APP_SERVER_API + '/auth/verify', config)
            .then( (response) => { this.setState({ ui: response.data.id, trial_used: response.data.trial_used===0?false:true, }); })
            .catch(err => {
                console.log(err, "You are not logged in or something went wrong with fetching data!")
                this.setState({ redirect: true });
            });
        const config_sub = { 
            headers: { Authorization: `Bearer ${token}`, }, 
            id: this.state.ui,
        };
        await axios.post(process.env.REACT_APP_SERVER_API + `/subs/subscription`, config_sub)
            .then((response) => { 
                this.setState({ 
                    status: response.data,
                }) 
                return response.data;
            })
            .catch((err)=>{ console.log(err, "Error in subscription retrieval") })
        await axios.get(process.env.REACT_APP_SERVER_API + `/read/status/${this.state.ui}`)
            .then((response) => { this.setState({ message_unread: response.data.status }); })
            .catch((err) => { console.log(err, "Error checking for message status!") })
        if (this.state.active) {
            await axios.get(process.env.REACT_APP_SERVER_API + `/myprofile/edit/${this.state.ui}`)
                .then( (response) => {
                    this.setState({ 
                        image: response.data.image,
                        user: response.data,
                    }); 
                })
                .catch( (err) => {console.log(err, "Error in retreiving  user details!"); this.setState({ event_error: true, isLoading: false, disabled: false })})
            await axios.get(process.env.REACT_APP_SERVER_API + `/profile/image/${this.state.ui}`)
                .then((response) => { this.setState({ image_url: response.data })})
                .then(()=> { this.setState({ isLoading: false }) })
                .catch((err) => {console.log(err, "my error...");  this.setState({ isLoading: false }) })
        } else {
            await axios.get(process.env.REACT_APP_SERVER_API + `/myprofile/edit/${this.state.ui}`)
                .then( (response) => {
                    this.setState({ 
                        image: response.data.image,
                        user: response.data,
                        non_active: true,
                    }); 
                })
                .catch( (err) => {console.log(err, "Error in retreiving  user details!"); this.setState({ event_error: true, isLoading: false, disabled: false })})
            await axios.get(process.env.REACT_APP_SERVER_API + `/profile/image/${this.state.ui}`)
                .then((response) => { this.setState({ image_url: response.data })})
                .then(()=> { this.setState({ isLoading: false }) })
                .catch((err) => {console.log(err, "my error...");  this.setState({ isLoading: false }) })
        };
    };
    onChange = (picture) => {
        this.setState({new_image: picture, file_name: picture[0].file.name});
    };
    async onSubmit(event) {
        event.preventDefault();
        if (this.state.new_image===null) {
            this.setState({ error: true, })
        } else {
            this.setState({ disabled: true, isLoading: true, error: false });
            const image = this.state.new_image;
            const data = new FormData();
            data.append('image', image[0].file, image[0].file.name);
            data.append('ui', this.state.ui);
            const config = { headers: { 'content-type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*' } };
            if (this.state.signed_in) {
                await axios.post(process.env.REACT_APP_SERVER_API + '/profile/upload/image', data, config)
                    .then((response) => console.log(response, "response from upload point in backend..."))
                    .catch(err => { this.setState({ disabled: false, isLoading: false, }); });
                alert('Profile image updated! 🚀');
                window.location = `/edit-image/${this.state.ui}`;
            } else {
                window.location = '/signin';
            };
        };
    };
    sign_out = () => {
        localStorage.removeItem('token');
        this.setState({ signed_in: false, FirstName: '' })
    }

    render() {
        if(this.state.redirect === true) return <Redirect to={{pathname: "/signin"}}/>
        let file_name;
        if (this.state.file_name) file_name = <p className="edit-profile-file-name">{this.state.file_name}</p>
        let image;
        if (this.state.image_url !== null) {
            image = this.state.isLoading ? '' : <div className="edit-profile-image-container-s3" style={{backgroundImage: `url(${this.state.image_url})`}}></div>
        } else {
            image = this.state.isLoading ? '' : <img className="edit-profile-image-image" src={user} alt="" />
        };
        let error_message = this.state.error===false?'':<p className="r">Please select an image!</p>
        let form;
        if (this.state.status.active_paid===true||this.state.status.on_trial===true) {
            form =
                <div className="edit-profile-image-edit-section">
                    { image }
                    <form onSubmit={this.onSubmit}>
                        {file_name}
                        {error_message}
                        <div className="edit-profile-image-icon-container">
                            <ImageUploading
                                multiple
                                value={this.state.file_name}
                                onChange={this.onChange}
                                // onChange={this.onDrop}
                                maxNumber={1}
                                dataURLKey="data_url"
                                acceptType={["jpg", "jpeg", "heic", "png", "gif", "webp", "heif"]}
                                allowNonImageType={true}
                            >
                                {({
                                onImageUpload,
                                isDragging,
                                dragProps,
                                }) => (
                                // write your building UI
                                <div className="upload__image-wrapper">
                                    <button
                                        type="button"
                                        className="edit-profile-image-button"
                                        style={isDragging ? { color: 'red' } : undefined}
                                        onClick={onImageUpload}
                                        {...dragProps}
                                    >
                                    Click or Drop here
                                    </button>
                                    &nbsp;
                                </div>
                                )}
                            </ImageUploading>
                        </div>
                        <button className="edit-profile-image-form-button" disabled={this.state.disabled ? true : false}>{this.state.disabled ? 'Updating...' : 'Update'}</button>
                        <Link to="/settings" className="no-dec"><button className="edit-profile-image-form-button back">Cancel</button></Link>
                    </form>
                </div>
        } else {
            form =
                <div className="edit-profile-image-edit-section">
                    {/* <p style={{fontSize: "15px", width: "90%", margin: "10px auto"}}>Looks like you don't have an active membership, please activate your membership to use Motorcyk's full features.</p>
                    <Link to={{ pathname: this.state.trial_used===false?"/signup-plan-trial":"/signup-plan", }}  className="no-dec" style={{marginBottom: "50px"}}><button className="edit-profile-form-button back">{this.state.trial_used===false?"Activate Free Trial":"Activate Membership"}</button></Link>
                    <hr style={{marginTop: "50px", width: "80%", opacity: ".50"}}/> */}
                    {this.state.status.active_paid===true||this.state.status.on_trial===true?'':<Link to={"/signup-plan"} className="r no-dec font-1 hover mobile">Subscribe To Motorcyk</Link>}
                    { image }
                    <form onSubmit={this.onSubmit}>
                        {file_name}
                        {error_message}
                        <div className="edit-profile-image-icon-container">
                            <ImageUploading
                                multiple
                                value={this.state.file_name}
                                onChange={this.onChange}
                                // onChange={this.onDrop}
                                maxNumber={1}
                                dataURLKey="data_url"
                                acceptType={["jpg", "jpeg", "heic", "png", "gif", "webp", "heif"]}
                                allowNonImageType={true}
                            >
                                {({
                                onImageUpload,
                                isDragging,
                                dragProps,
                                }) => (
                                // write your building UI
                                <div className="upload__image-wrapper">
                                    <button
                                        type="button"
                                        className="edit-profile-image-button"
                                        style={isDragging ? { color: 'red' } : undefined}
                                        onClick={onImageUpload}
                                        {...dragProps}
                                    >
                                    Click or Drop here
                                    </button>
                                    &nbsp;
                                </div>
                                )}
                            </ImageUploading>
                        </div>
                        <button className="edit-profile-image-form-button" disabled={this.state.disabled ? true : false}>{this.state.disabled ? 'Updating...' : 'Update'}</button>
                        <Link to="/settings" className="no-dec"><button className="edit-profile-image-form-button back">Cancel</button></Link>
                    </form>
                </div>
        };
        const body = this.state.isLoading?<Loading />: 
            <div className="edit-profile-image-container">
                <div className="home-header">
                    <h5 className="home-header-title"><Link to="/" className="no-dec"><img className="header-logo" src={logo} alt="" /></Link></h5>
                    <ul className="home-header-items no-dec mobile">
                        {(this.state.status.active_paid===true||this.state.status.on_trial===true || (this.state.status.canceled===true && this.state.status.canceled_access===true))?<li><Link to="/messages" className="home-message-link no-dec r"><img className="home-messages-icon" style={{width: 24, height: 24}} src={messages} alt="" />{this.state.message_unread ? <img className="home-message-dot" src={dot} alt="" /> : null}</Link></li>: <li><Link to="/" onClick={this.sign_out} className="home-message-link no-dec r"><img className="home-messages-icon" style={{width: 24, height: 24}} src={logout} alt="" /></Link></li>}
                        {(this.state.status.active_paid===true||this.state.status.on_trial===true||(this.state.status.canceled===true&&this.state.status.canceled_access===true))?'':<li><Link to="/messages" className="home-message-link no-dec r"><img className="home-messages-icon" style={{width: 24, height: 24}} src={messages} alt="" />{this.state.message_unread ? <img className="home-message-dot" src={dot} alt="" /> : null}</Link></li>}
                        <li ><Link to={`/profile/${this.state.ui}`} className="home-profile-link no-dec r"><img className="home-user-icon" style={{borderRadius: '50%', width: 25, height: 25}} src={this.state.image_url ? this.state.image_url : user} alt="" /></Link></li>
                    </ul>
                    <ul className="home-header-items no-dec td">
                    {/* {this.state.status.active_paid===true||this.state.status.on_trial===true?'':<li ><Link to="/" onClick={this.sign_out} className="home-home-link no-dec b">Sign Out</Link></li>} */}
                        <li><Link to="/settings" className="home-settings-link no-dec b">Settings</Link></li>
                        <li><Link to="/explore" className="home-explore-link no-dec b">Explore</Link></li>
                        <li><Link to="/host" className="home-host-link no-dec b">Host</Link></li>
                        <li><Link to="/messages" className="home-message-link no-dec b">Messages {this.state.message_unread ? <img className="home-message-dot" src={dot} alt="" /> : null}</Link></li>
                        <li ><Link to={`/profile/${this.state.ui}`} className="home-profile-link no-dec b">Profile</Link></li>
                        {this.state.status.active_paid===true||this.state.status.on_trial===true?<li ><Link to="/home" className="home-home-link no-dec b">Home</Link></li>:''}
                        {this.state.status.active_paid===false&&this.state.status.on_trial===false?<li><Link to={{ pathname: this.state.trial_used===false?"/signup-plan-trial":"/signup-plan", }}  className="home-settings-link no-dec b">{this.state.trial_used===false?"Activate Free Trial":"Subscribe"}</Link></li>:''}
                    </ul>
                </div>
                <div className="edit-profile-image-title-container">
                    <h1 className="edit-profile-image-title">Edit Profile Image</h1>
                </div>
                { form }
                <MobileFooterNav data={{ id: this.state.ui, path: this.props.location.pathname }}/>
            </div>
        return (
            <div>{ body }</div>
        );
    };
};
export default EditImage;